// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"560":"be2622f3","995":"35485725"}[chunkId] + ".css";
};